/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.TranslationsRpc
 */
import * as References from './TranslationsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { registerQuery } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.TranslationsRpc#listPortalTranslations
 */
export const LIST_PORTAL_TRANSLATIONS_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_TranslationsRpc_listPortalTranslations';
export const LIST_PORTAL_TRANSLATIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_PORTAL_TRANSLATIONS_QUERY_FIELD_NAME,
  args: ['locale', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.listPortalTranslationsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});